/**
 * GameBackgroundPortraitProperties.ts
 */
import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { GameBackgroundProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameBackgroundProperties";
import { PawnAssetStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/PawnAssetStyle";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Point } from "pixi.js";
export class GameBackgroundPortraitProperties extends GameBackgroundProperties {
    constructor() {
        super(...arguments);
        this.frameProperties = new SpriteProperties(PawnAssetStyle.Frame.portrait, GameStyle.MODULE, new Point(-11.5, 354.5));
        this.baseBackgroundProperties = new SpriteProperties(PawnAssetStyle.Background.portrait, GameStyle.MODULE, new Point(-461, 0));
    }
}
